// ControlValueFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import ValueControlView  from 'report/ValueControlView.js';


//=============================================================================
//
// Creates one of five kinds of text control, given a factoryService
// parameter key and a layout postion. The factory key defines the 
// control appearance through its template. It defines the  initial rectangle
// of the control via a width and height from the factory parameter.
//
// -Rene Lopez, 09/09/2016
//
//=============================================================================
class ControlValueFactory extends BaseVisualControlFactory {

	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes( factoryKey, pos ) ;
  		//adding silent(accessibility) to attributes.
		attributes.additiveDynamicFilter = true;
		attributes.ignoreNull = false;
		attributes.setDynamicFilter = true;
  		attributes.silent = false;
		attributes.styleColorText = '~textColor';
		attributes.fontFamily = '~textFont';
		attributes.fontSize = '~textFont';
		attributes.textWeight = '~textFont';
		attributes.textStyle = '~textFont';
		attributes.sharedSettingsTitle = 'Value Shared Settings';
		attributes.tabSettingsTitle = 'Value Settings';
		attributes.dataValuePrimary='none';
		attributes.dataValueSecondary='none';
		attributes.canSetDynamicFilter=true;
		attributes.format='none';
		attributes.value='123';
		attributes.formattedValue=attributes.value;
		attributes.formatOption = '';
		attributes.tabEnabled = false;
		attributes.respectDynamicFilter = true;
		attributes.currentFormat = {
			decimals: '2',
			decimalSeparator: ',',
			symbol: '',
			thousandSeparator: '',
			dateFormat: 'ddmmyy',
			hour24: true,
			showSeconds: false,
			yesValue: '',
			noValue: '',
			percentageDecimals: '2'
		};
		attributes.Columns = { Column: [{id:'0', Properties: {
			usesExpression: "false",
			formatoption: "",
			fieldId: "",
			width: "150",
			format: "none",
			caption: "",
			sortType: "none",
			visible: "true",
			setDynamicFilter: "false",
			align: "left",
			aggregation: "count",
			fieldDataType: "",
			sortOrder: "0"
		}}
		]};
        attributes.resizePadding = 2;
		attributes.minWidth = 10;
		attributes.minHeight = 10;
		attributes.lowestHeight = 10;

        const view = new ValueControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            							pos: pos, factoryKey: factoryKey, id: attributes.id} );

		return view;
	}

}

const controlValueFactory = new ControlValueFactory();

export default controlValueFactory;
